import { FullPatientFragment } from 'src/participant/patientQueries.generated'
import { PatientDetails } from 'src/participant/types'

export type RequiredField = 'firstname' | 'lastname' | 'birthDate' | 'phone' | 'insuranceMemberID'

export type ValidationResult = {
  isValid: boolean
  missingFieldLabels: string[]
}

const FIELD_LABELS: Record<RequiredField, string> = {
  firstname: 'first name',
  lastname: 'last name',
  birthDate: 'birthdate',
  phone: 'phone number',
  insuranceMemberID: 'insurance member ID',
}

export const validateParticipantInfo = (
  participant: FullPatientFragment,
  details: PatientDetails
): ValidationResult => {
  const missingFields: RequiredField[] = []

  if (!participant.firstname?.trim()) {
    missingFields.push('firstname')
  }

  if (!participant.lastname?.trim()) {
    missingFields.push('lastname')
  }

  if (!participant.birthDate) {
    missingFields.push('birthDate')
  }

  if (!participant.phone?.trim()) {
    missingFields.push('phone')
  }

  if (!details.memberID?.trim()) {
    missingFields.push('insuranceMemberID')
  }

  const missingFieldLabels = missingFields.map((field) => FIELD_LABELS[field])

  return {
    isValid: missingFields.length === 0,
    missingFieldLabels,
  }
}

export const getMissingInfoMessage = (missingFieldLabels: string[]): string => {
  if (missingFieldLabels.length === 0) return ''

  if (missingFieldLabels.length === 1) {
    return `${missingFieldLabels[0]} is required`
  }

  if (missingFieldLabels.length === 2) {
    return `${missingFieldLabels[0]} and ${missingFieldLabels[1]} are required`
  }

  const lastField = missingFieldLabels[missingFieldLabels.length - 1]
  const otherFields = missingFieldLabels.slice(0, -1).join(', ')
  return `${otherFields}, and ${lastField} are required`
}
